export default {"src":"/_next/static/media/right_arrow.c71d5b81.svg","height":25,"width":17,"blurWidth":0,"blurHeight":0};